import {
  CompanyStructureForPlanningResponse,
  CompanyStructureSchool
} from '@/types/service-response'

export class School {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: CompanyStructureForPlanningResponse): Array<School> {
    let result: Array<School> = []
    if (responseData.kantons) {
      result = responseData.kantons.map((school: CompanyStructureSchool) => {
        return new School(
          school.ID,
          school.Name,
        )
      })
    }
    return result
  }
}
